import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';

import { ProvedorDeSessao } from '@/features/autenticacao/ProvedorDeSessao';
import { ErroDeApi } from '@/lib/erros';

interface ProvedoresProps {
  children: ReactNode;
}

function criarQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,

        /**
         * Nao insistir em erro do cliente. 401, 403 e 404 nao melhoram com
         * repeticao, e 409 de transicao invalida e resposta legitima da
         * maquina de estados: repetir apenas atrasaria o feedback.
         */
        retry: (tentativas, erro) => {
          if (erro instanceof ErroDeApi && erro.status >= 400 && erro.status < 500) {
            return false;
          }

          return tentativas < 2;
        },
      },
      mutations: {
        retry: false,
      },
    },
  });
}

export function Provedores({ children }: ProvedoresProps) {
  // useState garante um cliente por montagem da aplicacao, e nao um singleton
  // de modulo, o que manteria cache entre testes.
  const [queryClient] = useState(criarQueryClient);

  // A sessao fica DENTRO do QueryClientProvider: ela limpa o cache no login e no
  // logout, e para isso precisa do cliente. E fica FORA do roteador, montado em
  // main.tsx, porque o guarda de rota le a sessao.
  return (
    <QueryClientProvider client={queryClient}>
      <ProvedorDeSessao>{children}</ProvedorDeSessao>
    </QueryClientProvider>
  );
}
